document.addEventListener("DOMContentLoaded", function () {
    const currencySelectors = document.querySelectorAll(".currency-selector");
    currencySelectors.forEach(selector => {
        const relativeFormSelector = selector.querySelector(".relative");
        disabledForm(relativeFormSelector);
    })

    const modalSelector = document.querySelector(".modal-selector");
    const triggerElements = document.querySelectorAll(".currency-selector, .modal-selector__overlay, .modal-content__close, .modal-content__button")

    if (!currencySelectors.length || !modalSelector) return;


    [...triggerElements].forEach(htmlElement => {
        htmlElement.addEventListener("click", toggleModal);
    });

    function toggleModal() {
        const navigationDrawer = this.closest("navigation-drawer") ? this.closest("navigation-drawer") : false;

        const isShow = modalSelector.hasAttribute("open");

        if (navigationDrawer && !isShow) {
            document.querySelector("navigation-drawer")?.dispatchEvent(new CustomEvent("dialog:force-close"));
        }
        
        modalSelector.toggleAttribute("open", !isShow);
        document.documentElement.classList.toggle("lock", !isShow);


    }

    function disabledForm(form) {
        if (!form) return;
        form.style.pointerEvents = "none"
    }

})